import EntityFormCreator from '../EntityFormCreator/EntityFormCreator';
import {formBodyType} from '../../../util/uiconstants';
import React from 'react';
import PropTypes from 'prop-types';

export default function ALRAIndividualAccountCreator(props) {
	const {bodyTypeId} = props;
	return (
		<EntityFormCreator
			text={props.text}
			bodyTypeId={bodyTypeId}
			skipConfirmation={props.skipConfirmation}
			onCreationFinished={props.onCreationFinished}
		/>
	);
}

ALRAIndividualAccountCreator.propTypes = {
	onCreationFinished: PropTypes.func.isRequired,
	skipConfirmation: PropTypes.bool,
	text: PropTypes.string.isRequired,
	bodyTypeId: PropTypes.string
};
